import { NavLink } from '@remix-run/react'
import { Home, Calendar, TrendingUp, Users, Wallet } from 'lucide-react'
import { useHints } from '../../utils/client-hints.tsx'

export const BottomNavBar = () => {
	const { isPWA } = useHints()
	const navBarClassName = isPWA ? 'pb-4 h-20' : 'h-16'

	return (
		<div
			className={`${navBarClassName} fixed bottom-0 left-0 z-50 w-full border-t border-gray-200 bg-iagtDarkBlue`}
		>
			<div className="mx-auto grid h-full max-w-2xl grid-cols-5 font-medium">
				<NavLink
					prefetch="intent"
					to="/"
					className={({ isActive }) =>
						`flex flex-col items-center justify-center px-2 ${
							isActive ? 'text-iagtGold' : 'text-gray-400 hover:text-iagtGold'
						}`
					}
				>
					<Home className="mb-1 h-6 w-6" />
					<span className="text-xs">Home</span>
				</NavLink>
				<NavLink
					prefetch="intent"
					to="/events"
					className={({ isActive }) =>
						`flex flex-col items-center justify-center px-2 ${
							isActive ? 'text-iagtGold' : 'text-gray-400 hover:text-iagtGold'
						}`
					}
				>
					<Calendar className="mb-1 h-6 w-6" />
					<span className="text-xs">Events</span>
				</NavLink>
				<NavLink
					prefetch="intent"
					to="/points"
					className={({ isActive }) =>
						`flex flex-col items-center justify-center px-2 ${
							isActive ? 'text-iagtGold' : 'text-gray-400 hover:text-iagtGold'
						}`
					}
				>
					<TrendingUp className="mb-1 h-6 w-6" />
					<span className="text-xs">Points</span>
				</NavLink>
				<NavLink
					prefetch="intent"
					to="/users"
					className={({ isActive }) =>
						`flex flex-col items-center justify-center px-2 ${
							isActive ? 'text-iagtGold' : 'text-gray-400 hover:text-iagtGold'
						}`
					}
				>
					<Users className="mb-1 h-6 w-6" />
					<span className="text-xs">Players</span>
				</NavLink>
				<NavLink
					prefetch="intent"
					to="/sponsor"
					className={({ isActive }) =>
						`flex flex-col items-center justify-center px-2 ${
							isActive ? 'text-iagtGold' : 'text-gray-400 hover:text-iagtGold'
						}`
					}
				>
					<Wallet className="mb-1 h-6 w-6" />
					<span className="text-xs">Sponsors</span>
				</NavLink>
			</div>
		</div>
	)
}
